export default [
  {
    title: "공동분야",
    list: [
      {
        title: "공통분야",
        content: "1. 이력카드의 구비 및 기록여부(소방계획서)",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "2. 안전관리자 선임여부 및 부재시 대응방안 수립 여부",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "3. 긴급재난시 대피지침 수립여부",
        isChecked: "",
      },
      {
        title: "공통분야",
        content: "4. 비상연락망 구비여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "건축분야",
    list: [
      {
        title: "주요시설",
        content: "1. 보의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "2. 기둥(내력벽 등)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "3. 슬래브(바닥판)의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "4. 주계단의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "5. 벽체의 변형 및 균열 상태",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "6. 지반 침하 및 이로 인한 활동적인 균열",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "7. 누수, 부식 등에 의한 구조물의 기능 상실",
        isChecked: "",
      },
      {
        title: "주요시설",
        content: "8. 주요강재의 변형 및 접합부 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "9. 지붕(옥상)의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "10. 계단실(복도)의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "11. 외벽타일 또는 석재의 균열 및 탈락상태",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "12. 시설 외부 또는 내부의 과하중(물탱크 등) 여부",
        isChecked: "",
      },
      {
        title: "일반시설",
        content: "13. 강재의 도장 및 관리상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "14. 옹벽, 석축 및 담장의 균열 및 상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "15. 마감재(광고판 등)의 돌출 및 위험요소(충돌, 안전사고) 여부",
        isChecked: "",
      },
      {
        title: "부대시설 - 일반",
        content: "16. 상 하수도주변 시설 파손 및 누수",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "17. 대형건설기계(타워크레인 등) 안전성 및 관리상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "18. 안전망 등의 설치여부 및 상태",
        isChecked: "",
      },
      {
        title: "부대시설 - 공사장",
        content: "19. 공사용 안전 가시설 등의 설치여부 및 상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "전기분야",
    list: [
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "1. 규격 전선의 사용 여부",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "2. 전선 접속 상태",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "3. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        title: "인입구 배선(육안으로 점검할 것)",
        content: "4. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "5. 규격전선의 사용 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "6. 전선 피복의 손상 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "7. 배선공사 방법의 적합 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "8. 비닐 코드선 사용 및 문어발 배선 사용 여부",
        isChecked: "",
      },
      {
        title: "옥내배선(옥외, 옥측배선 포함)(육안으로 점검할 것)",
        content: "9. 보행로 전선 노출여부",
        isChecked: "",
      },
      {
        title: "누전차단기",
        content: "10. 누전차단기 적정 설치 및 정상 작동 여부",
        isChecked: "",
      },
      {
        title: "누전차단기",
        content: "11. 열화 및 손상 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "12. 개폐기의 적정설치 및 설치위치의 적합 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "13. 개폐기의 열화 및 손상 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "14. 정격퓨즈의 사용 여부",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "15. 개폐기의 결선 상태",
        isChecked: "",
      },
      {
        title: "개폐기(차단기를 포함한다)",
        content: "16. 다선식 선로의 각극 개폐장치 여부",
        isChecked: "",
      },
      {
        title: "비상전원설비",
        content: "17. 정전시 비상전원확보(비상발전기, UPS) 및 정상운전 여부",
        isChecked: "",
      },
      {
        title: "배 전 반",
        content: "18. 배전함 커버손상 및 사용하지 않는 콘센트의 밀봉여부",
        isChecked: "",
      },
      {
        title: "부하설비",
        content: "19. 전기기계기구 금속제 외함 접지 및 접지용 콘센트 사용여부",
        isChecked: "",
      },
      {
        title: "조명시설",
        content: "20. 조명탑 등 전기시설물 유지관리상태",
        isChecked: "",
      },
    ],
  },
  {
    title: "기계분야",
    list: [
      {
        title: "시설영역",
        content: "1. 배관의 파손･누수･누기 및 유지관리 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "2. 보일러, 공조시설 및 설비배관 부식 여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "3. 보일러, 공조시설 환기상태 및 배출기 작동여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "4. 기계실 모든 자재의 정리 정돈 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "5. 지하설비 누수 상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "6. 급수･급탕･공조시설 관리 및 안전성",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "7. 오･폐수처리시설 가동상태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "8. 기계식주차시설･주차타워 등의 안전관리 실태",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "9. 화재 등 비상시 승강기의 비상운전 작동상태 여부",
        isChecked: "",
      },
      {
        title: "시설영역",
        content: "10. 승강기 내･외부 안전표지 부착 확인 등",
        isChecked: "",
      },
    ],
  },
  {
    title: "가스분야",
    list: [
      {
        title: "현장안전관리 상태검사",
        content: "1. 가스누출 여부(비누방울 시험법)",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "2. 가스누출 경보기 정상 작동여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "3. 중간밸브와 자동차단장치 정상 작동여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "4. 노출배관 및 부속물 유지관리 상태",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "5. 철거된 가스시설의 배관 또는 호스 끝 마감 처리 여부",
        isChecked: "",
      },
      {
        title: "현장안전관리 상태검사",
        content: "6. 호스 T 사용 여부 및 호스 3m 이상 사용여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "7. 저장용기 보관실 설치여부 및 위험물표시(100kg 이하는 차양조치)",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "8. 보일러실에 보일러 이외의 적치물 보관여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "9. 가스보일러가 전용 보일러실에 설치 되었는지 여부",
        isChecked: "",
      },
      {
        title: "시설 유지관리 상태검사",
        content: "10. 가스저장탱크 안전거리 유지여부(화기와의 거리 유지)",
        isChecked: "",
      },
    ],
  },
  {
    title: "교량분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        title: "배수시설",
        content: "∙ 배수관 파손에 따른 낙하위험 유무",
        isChecked: "",
      },
      {
        title: "배수시설",
        content: "∙ 배수관 막힘·물고임의 발생여부",
        isChecked: "",
      },
      {
        title: "신축이음",
        content: "∙ 유간이격의 발생 여부",
        isChecked: "",
      },
      {
        title: "신축이음",
        content: "∙ 단차의 발생 여부",
        isChecked: "",
      },
      {
        title: "신축이음",
        content: "∙ 파손의 발생 여부",
        isChecked: "",
      },
      {
        title: "받침부",
        content: "∙ 받침장치 파손의 발생 여부",
        isChecked: "",
      },
      {
        title: "받침부",
        content: "∙ 받침부 균열, 파손의 발생 여부",
        isChecked: "",
      },
      {
        title: "받침부",
        content: "∙ 받침편기의 발생 여부",
        isChecked: "",
      },
      {
        title: "받침부",
        content: "∙ 받침과 거더의 분리 여부",
        isChecked: "",
      },
      {
        title: "교대·교각",
        content: "∙ 균열의 발생 여부",
        isChecked: "",
      },
      {
        title: "교대·교각",
        content: "∙ 파손의 발생 여부",
        isChecked: "",
      },
      {
        title: "교대·교각",
        content: "∙ 변형, 회전의 발생 여부",
        isChecked: "",
      },
      {
        title: "기초",
        content: "∙ 세굴의 발생 여부",
        isChecked: "",
      },
      {
        title: "기초",
        content: "∙ 침하의 발생 여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "터널분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        title: "갱문 및 옹벽",
        content: "∙ 신규균열·박락발생 유무",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 세굴 발생여부",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 융기 발생여부",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 주변지반의 침하 발생여부",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 시공이음부 단차발생 유무",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 배수구 막힘 여부",
        isChecked: "",
      },
      {
        title: "갱문 및 옹벽",
        content: "∙ 배수시 흙, 모래 유출여부",
        isChecked: "",
      },
      {
        title: "갱구주변 경사면",
        content: "∙ 균열의 발생여부",
        isChecked: "",
      },
      {
        title: "갱구주변 경사면",
        content: "∙ 침하 또는 융기의 발생 여부",
        isChecked: "",
      },
      {
        title: "갱구주변 경사면",
        content: "∙ 새로운 지하수 유출지점 발생 여부",
        isChecked: "",
      },
      {
        title: "갱구주변 경사면",
        content: "∙ 수목의 전도 여부",
        isChecked: "",
      },
      {
        title: "갱구주변 경사면",
        content: "∙ 낙석 발생 여부",
        isChecked: "",
      },
      {
        title: "사면 보호공 또는 보강공",
        content: "∙ 단차발생 여부",
        isChecked: "",
      },
      {
        title: "사면 보호공 또는 보강공",
        content: "∙ 보호공 또는 보강공 파손발생 여부",
        isChecked: "",
      },
      {
        title: "사면 보호공 또는 보강공",
        content: "∙ 배수공의 막힘 여부",
        isChecked: "",
      },
      {
        title: "사면 보호공 또는 보강공",
        content: "∙ 모르터 표면의 습윤여부",
        isChecked: "",
      },
    ],
  },
  {
    title: "사면(급경사지)분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    footer: "※ 기초 세굴·부등침하 및 주요 구조부의 균열 등 <b>중대 결함</b>이 <b>발견</b> 된 경우 <b>민간전문가</b> 및 <b>점검장비</b>를 활용하여 <b>확인점검</b> 실시",
    list: [
      {
        title: "경사면내는 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 수목 전도 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 뜬 돌 존재 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 하단부 침식 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 지하수 유출 및 탁수의 용출 없어야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        content: "- 사면 붕괴 이력 및 규모, 위치는 관리하여야 함",
        isChecked: "",
      },
      {
        title: "경사면내는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 균열 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 융기(배부름) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 낙석 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로가 설치되어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        content: "- 사면 종・횡단배수로 막힘이 없어야 함",
        isChecked: "",
      },
      {
        title: "상 · 하부 사면 및 도로면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 평면상 높낮이 차(단차) 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 모르터 표면 습윤 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 배수공 막힘 등 배수기능 저하 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 보호․보강 구조물 파손발생 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        content: "- 소규모 낙석, 붕괴에 의한 보호․보강 효과 저하 없어야 함",
        isChecked: "",
      },
      {
        title: "보호공 혹은 보강공 등 구조물은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "옹벽 분야",
    tableHeaderNote: [
      { text: "내용(위치, 상태)", width: "240" },
      { text: "조치사항", width: "240" },
    ],
    list: [
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 균열이 발생하지 않아야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 이음부 이격 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 전면부 배부름(돌출) 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 주변부 탁한 용수유출 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 낙석 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 단차, 전도 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        content: "- 배수구 막힘이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 전면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 지반의 균열 및 침하 발생 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 배수로의 기능저하 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 옹벽 인접 교목 식생(2m이내) 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        content: "- 콘크리트 파손 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 배면은 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 지반융기가 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 옹벽 침하가 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 주변부 탁한 용수유출이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 세굴의 발생이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        content: "- 기초부 지반활동으로 인한 기울어짐이 없어야 함",
        isChecked: "",
      },
      {
        title: "옹벽 기초부는 안전한가?",
        rowType: "textarea",
        content: "기타 점검 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "항만(외곽시설)",
    tableHeaderTitle: "평가항목",
    tableHeaderCheck: [],
    tableHeaderNote: [
      { text: "점검결과", width: "auto" },
      { text: "비고", width: "240" },
    ],
    footer: "주) 1. 점검결과 발견된 결함의 정도, 위치, 형상 진행여부 등을 기술 <br/><p class='ml-6'>2. 점검로는 설치 유,무 및 점검자(책임기술자) 판단에 따라 보수의 필요성 여부를 체크</p>",
    list: [
      {
        title: "상부공 및 직립부",
        content: "침하",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "경사/전도",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "활동",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "파손",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "균열",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "박리",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "마모/침식",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "속채움재 유실",
        isChecked: "",
      },
      {
        title: "상부공 및 직립부",
        content: "블록 및 케이슨 이격",
        isChecked: "",
      },
      {
        title: "사석 경사면",
        content: "사면변화",
        isChecked: "",
      },
      {
        title: "사석 경사면",
        content: "피복석 유실",
        isChecked: "",
      },
      {
        title: "소파공",
        content: "교란 및 유실",
        isChecked: "",
      },
      {
        title: "소파공",
        content: "파손",
        isChecked: "",
      },
      {
        title: "기초부",
        content: "세굴",
        isChecked: "",
      },
      {
        title: "기초부",
        content: "기초사석 교란",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "계선주",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "차막이",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "방충재",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "등대",
        isChecked: "",
      },
      {
        title: "기타",
        rowType: "radio",
        content: "점검로",
        contentRadio: [{ value: "유" }, { value: "무" }],
        noteRadio: [{ value: "보수필요" }, { value: "보수불필요" }],
        isChecked: "",
      },
      {
        title: "기타",
        content: "기타",
        isChecked: "",
      },
    ],
  },
  {
    title: "항만(잔교식 안벽)",
    tableHeaderTitle: "평가항목",
    tableHeaderCheck: [],
    tableHeaderNote: [
      { text: "점검결과", width: "auto" },
      { text: "비고", width: "240" },
    ],
    footer:
      "주) 1. 점검결과 발견된 결함의 정도, 위치, 형상 진행여부 등을 기술<p class='ml-6'>2. 잔교식 돌핀 시설도 이 양식을 변형 활용 가능</p><p class='ml-6'>3. 점검로는 설치 유,무 및 점검자(책임기술자) 판단에 따라 보수의 필요성 여부를 체크</p>",
    list: [
      {
        title: "수상부",
        content: "콘크리트 바닥판",
        isChecked: "",
      },
      {
        title: "수상부",
        content: "콘크리트 세로보 및 가로보",
        isChecked: "",
      },
      {
        title: "수상부",
        content: "콘크리트 말뚝",
        isChecked: "",
      },
      {
        title: "수상부",
        content: "토류벽",
        isChecked: "",
      },
      {
        title: "수상부",
        content: "강말뚝",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "방충재",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "계선주",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "차막이",
        isChecked: "",
      },
      {
        title: "기타",
        rowType: "radio",
        content: "점검로",
        contentRadio: [{ value: "유" }, { value: "무" }],
        noteRadio: [{ value: "보수필요" }, { value: "보수불필요" }],
        isChecked: "",
      },
      {
        title: "기타",
        content: "기타",
        isChecked: "",
      },
      {
        rowType: "textarea",
        content: "특기사항",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        rowType: "textarea",
        content: "점검자 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "항만(중력식 안벽)",
    tableHeaderTitle: "평가항목",
    tableHeaderCheck: [],
    tableHeaderNote: [
      { text: "점검결과", width: "auto" },
      { text: "비고", width: "240" },
    ],
    footer:
      "주) 1. 점검결과 발견된 결함의 정도, 위치, 형상 진행여부 등을 기술<p class='ml-6'>2. 잔교식 돌핀 시설도 이 양식을 변형 활용 가능</p><p class='ml-6'>3. 점검로는 설치 유,무 및 점검자(책임기술자) 판단에 따라 보수의 필요성 여부를 체크</p>",
    list: [
      {
        title: "상부공 및 본체부",
        content: "침하",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "경사/전도",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "활동",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "파손",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "균열",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "박리",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "마모/침식",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "속채움재 유실",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "이격",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "방충재",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "계선주",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "차막이",
        isChecked: "",
      },
      {
        title: "기타",
        rowType: "radio",
        contentRadio: [{ value: "유" }, { value: "무" }],
        noteRadio: [{ value: "보수필요" }, { value: "보수불필요" }],
        content: "점검로",
        isChecked: "",
      },
      {
        title: "기타",
        content: "기타",
        isChecked: "",
      },
      {
        rowType: "textarea",
        content: "특기사항",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        rowType: "textarea",
        content: "점검자 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "항만(널말뚝식 안벽)",
    tableHeaderTitle: "평가항목",
    tableHeaderCheck: [],
    tableHeaderNote: [
      { text: "점검결과", width: "auto" },
      { text: "비고", width: "240" },
    ],
    footer: "주) 1. 점검결과 발견된 결함의 정도, 위치, 형상 진행여부 등을 기술<p class='ml-6'>2. 점검로는 설치 유,무 및 점검자(책임기술자) 판단에 따라 보수의 필요성 여부를 체크</p>",
    list: [
      {
        title: "상부공 및 본체부",
        content: "침하",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "변형",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "활동",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부",
        content: "후면부 함몰",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 콘크리트 널말뚝",
        content: "균열",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 콘크리트 널말뚝",
        content: "마모",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 콘크리트 널말뚝",
        content: "마모/침식",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 강널말뚝",
        content: "부식",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 강널말뚝",
        content: "마모/침식",
        isChecked: "",
      },
      {
        title: "상부공 및 본체부 - 강널말뚝",
        content: "도장손상",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "방충재",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "계선주",
        isChecked: "",
      },
      {
        title: "부대시설",
        content: "차막이",
        isChecked: "",
      },
      {
        title: "기타",
        rowType: "radio",
        contentRadio: [{ value: "유" }, { value: "무" }],
        noteRadio: [{ value: "보수필요" }, { value: "보수불필요" }],
        content: "점검로",
        isChecked: "",
      },
      {
        title: "기타",
        content: "기타",
        isChecked: "",
      },
      {
        rowType: "textarea",
        content: "특기사항",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
      {
        rowType: "textarea",
        content: "점검자 의견",
        placeholder: "* 개선 또는 보완이 필요한 사항 등 기술",
      },
    ],
  },
  {
    title: "집단급식소",
    list: [
      {
        title: "1. 설치신고 사항 (법 제88조)",
        content: "· 집단급식소 설치 신고 여부",
        isChecked: "",
      },
      {
        title: "1. 설치신고 사항 (법 제88조)",
        content: "· 설치변경신고 여부(신고사항 임의변경 등)",
        isChecked: "",
      },

      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 조리장 바닥에 배수구가 있는 경우 덮개 설치",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 조리시설, 세척시설, 폐기물용기 및 손씻는 시설",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 폐기물용기(오물, 악취 등이 누출되지 않도록 뚜껑이 있는 내수성 재질)",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 자외선 또는 전기살균소독기를 설치하거나 열탕 세척 소독 시설",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 충분한 환기 시설(자연 통풍 가능 구조는 제외)",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 보존 및 보관기준에 적합한 온도가 유지될 수 있는 냉장･냉동시설",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 식품과 직접 접촉하는 부분은 위생적인 내수성 재질로서 씻기 쉽고, 열탕･증기･살균제 등으로 소독･살균이 가능",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 쥐･해충 등을 막을 수 있는 시설",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 바닥, 벽, 천장, 폐기물용기, 환기시설, 방충시설 등의 청결 관리",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 수돗물이나 먹는물의 수질기준에 적합한 지하수 등을 공급할 수 있는 시설",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 지하수를 사용하는 경우 취수원이 오염원의 영향을 받지 아니하는 곳에 위치\n- 축산농가의 분뇨 유입 가능성 여부 등",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 지하수를 사용하는 경우 용수저장장치에 살균소독장치를 설치",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 식품등을 위생적으로 보관할 수 있는 창고를 갖추었는지 여부",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실은 조리장에 영향을 미치지 아니하는 장소에 설치\n※ 집단급식소가 위치한 건축물안에 시설기준에 적합한 공동화장실이 설치되어 있거나 인근에 사용하기 편리한 화장실이 있는 경우 제외",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 수세식이 아닌 화장실인 경우 변기의 뚜껑과 환기시설 구비",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실은 콘크리트 등으로 내수처리를 하고, 바닥과 내벽(바닥으로부터 1.5미터까지)에는 타일을 붙이거나 방수페인트로 색칠",
        isChecked: "",
      },
      {
        title: "2. 시설 등 환경 (법 제88조)",
        content: "· 화장실 내에 손을 씻는 시설",
        isChecked: "",
      },

      {
        title: "3.건강진단 (법 제40조)",
        isChecked: "",
        contentType: 1,
      },

      {
        title: "4. 개인위생 (법 제3조)",
        content: "· 식품등의 제조･가공･조리 또는 포장에 직접 종사하는 자는 위생모를 착용하는 등 개인위생관리에 철저를 기하는지 여부",
        isChecked: "",
      },
      {
        title: "4. 개인위생 (법 제3조)",
        content: "· 식품의 조리 시 마스크 착용 여부",
        isChecked: "",
      },

      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 무허가(무신고·무등록)  원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 부패･변질된 원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 무표시 원료 및 식품의 사용여부",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 검사를 받지 아니한 축산물의 사용 유무",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 유통기한이 경과된 원료 또는 완제품을 조리할 목적으로 보관･사용",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 지하수 등을 먹는물 또는 식품의 조리, 세척 등에 사용하는 경우 먹는물수질검사기관에서 검사를 받아 마시기에 적합하다고 인정된 물을 사용하는지 여부\n(연1회 일부항목검사, 2년마다 전항목 검사)",
        isChecked: "",
      },
      {
        title: "5. 원료사용 (법 제4조, 제15조, 제88조)",
        content: "· 위해평가가 완료되기 전 일시적으로 금지된 식품 등 사용, 조리",
        isChecked: "",
      },

      {
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 원료보관실, 제조가공실, 포장실등의 내부를 청결하게 관리",
        isChecked: "",
      },
      {
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 동물의 내장을 조리한 경우 사용한 기계기구류 등을 세척･살균",
        isChecked: "",
      },
      {
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 위생적인 방법으로 해동 실시하고, 해동 후 바로 사용하지 않는 경우 조리 시까지 냉장보관, 해동제품에 대한 재냉동 금지",
        isChecked: "",
      },
      {
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 물수건, 숟가락, 젓가락, 식기, 찬기, 도마, 칼 및 행주 기타 주방용구는 식품첨가물인 기구 등 살균, 소독제 또는 열탕의 방법으로 소독한 것을 사용",
        isChecked: "",
      },
      {
        title: "6. 공정관리 (법 제3조,  제88조)",
        content: "· 어류･육류･채소류를 취급하는 칼･도마는 각각 구분하여 사용",
        isChecked: "",
      },

      {
        title: "7. 공정관리 (법 제3조, 제88조)",
        content: "· 식품등의 보관, 운반, 진열시에는 보존 및 보관기준(냉장 10℃, 냉동 -18℃ 이하)에 적합하도록 관리",
        isChecked: "",
      },
      {
        title: "7. 공정관리 (법 제3조, 제88조)",
        content: "· 냉동･냉장시설 및 가열처리시설에는 온도계 또는 온도 측정 계기 설치",
        isChecked: "",
      },

      {
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 집단급식소 설치운영자와 위탁계약한 사항 외의 영업행위를 하는지",
        isChecked: "",
      },
      {
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 조리･제공한 식품(간식 포함)의 매회 1인분 분량을 -18℃ 이하에서 144시간 이상 보관하는지",
        isChecked: "",
      },
      {
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 집단급식소의 설치･운영자가 위생교육을 받았는지\n※ 위탁급식영업자의 경우 영업자 위생교육 이수 여부",
        isChecked: "",
      },
      {
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 조리사, 영양사 채용 및 교육 이수 여부\n※ 100인 미만 산업체 집단급식소의 경우 예외",
        isChecked: "",
      },
      {
        title: "8. 기타관리 (법 제41조, 법 제44조, 제88조, 령 제36조, 령 제37조)",
        content: "· 영리 목적의 영업 여부(불특정 다수에게 급식 제공 등)",
        isChecked: "",
      },
    ],
  },
];
